<template>
  <Icon
    src=""
    :class="[{ active }, iconClass, iconColor]"
    class="fa icon-24 rounded-circle icon-control align-self-center"
  />
</template>

<script lang="ts">
import Icon from '@gecko-akh/aos-icon';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  components: {
    Icon,
  },
  props: {
    type: {
      type: String as PropType<'close' | 'edit' | 'pin' | 'left' | 'right' | 'info' | 'delete'>,
      default: 'close',
    },
    color: {
      type: String as PropType<'color-expinet-blue' | 'color-aida-red'>,
      default: 'color-expinet-blue',
    },
    active: { type: Boolean, default: false },
    iconColor: {
      type: String as PropType<'icon-theme-blue' | 'icon-theme-red'>,
      default: 'icon-theme-blue',
    },
  },
  computed: {
    iconClass() {
      switch (this.type) {
        case 'close':
          return 'fa-times'
        case 'edit':
          return 'fa-pencil'
        case 'pin':
          return 'fa-thumb-tack'
        case 'left':
          return 'fa-chevron-left'
        case 'right':
          return 'fa-chevron-right'
        case 'info':
          return 'fa-info'
        case 'delete':
          return 'fa-trash'
        default:
          return 'fa-times'
      }
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.icon-control {
  cursor: pointer;
  border-width: 2px;
  border-style: solid;
  border-color: var(--color-border);
  color: var(--color);

  // TODO: remove when AEM is implemented
  &:before {
    display: flex;
    justify-content: center;
    padding-top: 4px;
  }

  &:hover {
    background-color: var(--color-background-hover);
    color: $color-aida-white;
    border-color: var(--color-border-hover);
  }

  &.active {
    background-color: var(--color-background-active);
    color: $color-aida-white;
    border-color: var(--color-border-active);
  }
}

.icon-theme-blue {
  --color: #{$color-expinet-blue};
  --color-border: #{$color-expinet-blue};
  --color-background-hover: #{$color-expinet-blue-h};
  --color-border-hover: #{$color-expinet-blue-h};
  --color-background-active: #{$color-expinet-blue-h};
  --color-border-active: #{$color-expinet-blue-h};
}

.icon-theme-red {
  --color: #{$color-aida-red};
  --color-border: #{$color-aida-red};
  --color-background-hover: #{$color-aida-red-h};
  --color-border-hover: #{$color-aida-red-h};
  --color-background-active: #{$color-aida-red-h};
  --color-border-active: #{$color-aida-red-h};
}
</style>
